export default __webpack_public_path__ + "static/media/sleeping_bag_dark.4559ea9a.png";